"use client";

import { isPreviewing } from "@builder.io/sdk-react";
import Script from "next/script";

import { CookieBannerData } from "@/libs/builder/validators/isCookieBannerData";

export const CookieBanner = ({
  cookieKey,
  cookieScriptUrl,
  isCookieMultiLanguage,
}: CookieBannerData) => {
  if (isPreviewing()) return null;

  return (
    cookieKey && (
      <>
        <Script
          src={cookieScriptUrl}
          data-domain-script={cookieKey}
          data-document-language={isCookieMultiLanguage ? "true" : "false"}
          defer
          strategy="lazyOnload"
        />
        <Script
          id="one-trust-optanonWrapper"
          type="text/javascript"
          strategy="lazyOnload"
        >
          {`function OptanonWrapper() {}`}
        </Script>
      </>
    )
  );
};
